import { inject } from '@angular/core';
import { Routes, Router, UrlTree } from '@angular/router';
import { LoginService, provideLoginRoutes } from 'login';
import { HubComponent } from 'src/app/pages/hub/hub.component';
import { LoadingComponent } from 'src/app/pages/loading/loading.component';
import { environment } from 'src/environments/environment';
import { debugAuth } from 'src/app/debug/auth-debug';

// Can only activate the hub if the user is signed in.
async function canActivateApp(): Promise<boolean | UrlTree> {
  const router = inject(Router);
  const loginService = inject(LoginService);
  const userEmail = await loginService.getUserEmail();
  debugAuth('hub guard evaluated', {
    currentUrl: router.url,
    userEmail: Boolean(userEmail),
    userEmailValue: userEmail,
    loginHost: environment.loginHost
  });
  return userEmail ? true : router.createUrlTree(['login']);
}

const routes: Routes = [
  { path: '', pathMatch: 'full', component: LoadingComponent },
  { path: 'hub', component: HubComponent, canActivate: [canActivateApp], runGuardsAndResolvers: 'always' }
];

routes.push(...provideLoginRoutes({ loginHost: environment.loginHost }));

debugAuth('routes registered', {
  loginHost: environment.loginHost,
  routes: routes.map((route: Routes[number]) => route.path)
});

export default routes;
